import React from "react"

import ComparisonView from "~components/pages/comparison"
import { ComparisonSeo } from "~components/pages/comparison/comparison-seo"
import AllyDvmCopy from "~components/pages/comparison/resources/allydvm"

const CompareAllyDvmPage = () => {
    return <ComparisonView copy={AllyDvmCopy} />
}

export default CompareAllyDvmPage

export const Head = () => <ComparisonSeo copy={AllyDvmCopy} />
